module.exports = "<a href=\"{{fileSrc}}\" target=\"_blank\">{{fileCaption}}</a>";